import { FC } from 'react'
import { Show, SimpleShowLayout } from 'react-admin'
import { HeaderTitle } from '../../components'
import { ConversationShowActions } from './Conversation.actions'
import ConversationDetails from './Conversation.details'

const CollaborationsShow: FC = () => (
  <Show
    actions={<ConversationShowActions />}
    title={<HeaderTitle source="titel" i18n="resources.conversations.title" />}
  >
    <SimpleShowLayout>
      <ConversationDetails />
    </SimpleShowLayout>
  </Show>
)

export default CollaborationsShow
